module.exports = __webpack_public_path__ + "img/mobile2.a11eb252.svg";